var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useRef } from "react";
import { makeStyles } from "@material-ui/core";
import DraggableList from "react-draggable-list";
import classNames from "classnames";
import { DragIndicatorIcon } from "../icons";
import { typography } from "../../shared/theme";
export function FTLDraggableList(_a) {
    var { children, className, componentConstructor, ComponentWrapperProps } = _a, otherProps = __rest(_a, ["children", "className", "componentConstructor", "ComponentWrapperProps"]);
    const classes = useStyles();
    const listRef = useRef(null);
    return (React.createElement("div", { ref: listRef, className: classNames(className, classes.list) },
        React.Children.map(children, (child) => child &&
            React.cloneElement(child, Object.assign(Object.assign({}, child.props), { className: classNames(classes.option, child.props.className), key: child.props.key }))),
        React.createElement(DraggableList, Object.assign({}, otherProps, { container: () => listRef.current, springConfig: { stiffness: 500, damping: 40 }, padding: 0, 
            //@ts-ignore
            template: ({ item, dragHandleProps, }) => {
                const component = componentConstructor(item);
                return (React.createElement("div", Object.assign({}, dragHandleProps, ComponentWrapperProps, { className: classNames(classes.option, ComponentWrapperProps === null || ComponentWrapperProps === void 0 ? void 0 : ComponentWrapperProps.className) }),
                    component,
                    React.createElement(DragIndicatorIcon, { color: "tertiary", className: classes.dragHandleIcon })));
            } }))));
}
const useStyles = makeStyles((theme) => ({
    list: {
        position: "relative",
    },
    option: Object.assign(Object.assign({ position: "relative" }, typography.unsupportedSemanticTags.listItemText), { backgroundColor: "#fff", color: theme.palette.text.primary, cursor: "pointer", outline: "none", padding: "4px 12px", "&:hover": {
            backgroundColor: "#f5f5f6",
            "& $dragHandleIcon": {
                visibility: "visible",
            },
        } }),
    dragHandleIcon: {
        position: "absolute",
        right: 6,
        top: 6,
        visibility: "hidden",
        cursor: "grab",
    },
}));
//# sourceMappingURL=index.js.map